export const JUST_LOGGED_IN_KEY = "opm_just_logged_in";
export const AUTH_REDIRECT_PATH_KEY = "auth_redirect_path";
export const CLAIM_RESULT_COOKIE = "okm-claim-result";
export const CHAT_CLAIM_RESULT_KEY = "okm-chat-claim-result";
/** Pre-OTP refusal of an optional saved conversation; authentication has not run. */
export const CHAT_CONVERSATION_NOT_OWNED = "CHAT_CONVERSATION_NOT_OWNED";
